import React from 'react';
import { motion } from 'framer-motion';
import { FlightSearch } from '../components/FlightSearch';
import { Services } from '../components/Services';
import { BrixleyPromo } from '../components/BrixleyPromo';
export function Home() {
  return <>
      {/* Hero Section */}
      <section className="relative min-h-[90vh] flex items-end justify-center pt-20 pb-16" data-id="element-273">
        {/* Background Image */}
        <div className="absolute inset-0 z-0" data-id="element-274">
          <div className="absolute inset-0 bg-gradient-to-b from-white/50 via-charcoal-900/40 to-charcoal-900/90 z-10" data-id="element-275" />
          <img src="https://images.unsplash.com/photo-1540962351504-03099e0a754b?q=80&w=2500&auto=format&fit=crop" alt="Private Jet in Sky" className="w-full h-full object-cover" data-id="element-276" />
        </div>

        <div className="relative z-10 w-full max-w-7xl mx-auto px-6 flex flex-col items-center" data-id="element-277">
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8
        }} className="text-center mb-12" data-id="element-278">
            <h1 className="text-5xl md:text-7xl font-serif text-white mb-6 drop-shadow-lg" data-id="element-279">
              Charter <span className="italic text-brand-300" data-id="element-280">Simplified.</span>
            </h1>
            <p className="text-lg md:text-xl text-white/90 max-w-2xl mx-auto font-light drop-shadow-md" data-id="element-281">
              Experience the ultimate freedom of private aviation. Seamless
              booking, transparent pricing, and unparalleled luxury.
            </p>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 40
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8,
          delay: 0.2
        }} className="w-full" data-id="element-282">
            <FlightSearch data-id="element-283" />
          </motion.div>
        </div>
      </section>

      {/* Stats / Trust Bar */}
      <section className="bg-brand-900 text-brand-100 py-12 border-y border-brand-800" data-id="element-284">
        <div className="max-w-7xl mx-auto px-6 grid grid-cols-2 md:grid-cols-4 gap-8 text-center divide-x divide-brand-800/50" data-id="element-285">
          <div data-id="element-286">
            <p className="text-3xl font-serif font-semibold text-white mb-1" data-id="element-287">
              20+
            </p>
            <p className="text-sm tracking-wider uppercase opacity-80" data-id="element-288">
              Years Experience
            </p>
          </div>
          <div data-id="element-289">
            <p className="text-3xl font-serif font-semibold text-white mb-1" data-id="element-290">
              24/7
            </p>
            <p className="text-sm tracking-wider uppercase opacity-80" data-id="element-291">
              Concierge Support
            </p>
          </div>
          <div data-id="element-292">
            <p className="text-3xl font-serif font-semibold text-white mb-1" data-id="element-293">
              100%
            </p>
            <p className="text-sm tracking-wider uppercase opacity-80" data-id="element-294">
              Safety Record
            </p>
          </div>
          <div data-id="element-295">
            <p className="text-3xl font-serif font-semibold text-white mb-1" data-id="element-296">
              Global
            </p>
            <p className="text-sm tracking-wider uppercase opacity-80" data-id="element-297">
              Network Access
            </p>
          </div>
        </div>
      </section>

      <Services data-id="element-298" />
      <BrixleyPromo data-id="element-299" />
    </>;
}